import {
    REQUEST_FETCH_BOOKING_LOGS,
    FETCH_BOOKING_LOGS_SUCCESS,
    FETCH_BOOKING_LOGS_ERROR,
  } from '../../../actions/reservations/booking/fetchBookingsLogs';
    
  const initialState = {
    logs: [],
   
    processing: false,
    fetching: false,
    message: "",
    error: "",
  };
  
  const bookingLogReducer = (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_FETCH_BOOKING_LOGS: {
        return {
          ...state,
          logs: [],
         
          processing: false,
          fetching: true,
          message: "",
          error: "",
        };
      }
      case FETCH_BOOKING_LOGS_SUCCESS: {
        return {
          ...state,
          logs: action.logs,
         
          processing: false,
          fetching: false,
          message: "",
          error: "",
        };
      }
      case FETCH_BOOKING_LOGS_ERROR: {
        return {
          ...state,
          logs: [],
         
          processing: false,
          fetching: false,
          message: "",
          error: action.error,
        };
      }
     
      default: {
        return state;
      }
    }
  };
  
  export default bookingLogReducer;
  